import "core-js/modules/es6.object.define-property";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Type } from '@nerdwallet/currency';
import { setTrk, TrkElement, TrkPageType, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
import { getLegacyId, getMatchScore } from '@nerdwallet/marketplace/selectors/credit-cards';
import classes from '@nerdwallet/base-styles/classes';
import MatchScoreRing from './match-score-ring';
import MatchScoreTooltip from './match-score-tooltip';
import styles from '../marketplace-product-card.module.less';
import ketoStyles from '../keto-product-card/keto-product-card.module.less';
var GOOD_MATCH_SCORE_RANGE_START = 70;

var MatchScoreCTA = function MatchScoreCTA(_ref) {
  var analytics = _ref.analytics,
      identity = _ref.identity,
      isKetoCard = _ref.isKetoCard,
      marketplaceEntity = _ref.marketplaceEntity,
      taxonomy = _ref.taxonomy;
  // TODO: once the match score is ready in Marketplace, define the selector in nwjs-marketplace as a
  // CC selector and use it here
  var matchScore = getMatchScore(marketplaceEntity); // If match score does not exist, don't render Match Score CTA

  if (!matchScore) {
    return null;
  }

  var matchScoreCTAText = 'Your NerdWallet';
  var matchScoreCTATextColor = 'neutral-darker';
  var matchScoreColor;
  var matchScoreRingColor;

  if (matchScore >= GOOD_MATCH_SCORE_RANGE_START) {
    matchScoreColor = 'green';
    matchScoreRingColor = 'green-lightest';
  } else {
    matchScoreColor = 'yellow';
    matchScoreRingColor = 'yellow-lightest';
  }

  var matchScoreIcon = /*#__PURE__*/React.createElement(MatchScoreRing, {
    matchScore: matchScore,
    matchScoreColor: matchScoreColor,
    matchScoreRingColor: matchScoreRingColor,
    isKetoCard: isKetoCard
  });

  var handleMatchScoreCTAOnClick = function handleMatchScoreCTAOnClick() {
    var _setTrk;

    window.location = setTrk((_setTrk = {
      url: "/recommend?matchScoreCTACardId=".concat(getLegacyId(marketplaceEntity)),
      taxonomy: taxonomy
    }, _defineProperty(_setTrk, TrkTag.element, TrkElement.button), _defineProperty(_setTrk, TrkTag.location, "match-score-cta--prodId".concat(getLegacyId(marketplaceEntity))), _defineProperty(_setTrk, TrkTag.pageType, TrkPageType.marketPlace), _setTrk));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: isKetoCard ? ketoStyles.matchScoreCTAKeto : styles.matchScoreCTA
  }, /*#__PURE__*/React.createElement("div", {
    className: classes('flex-direction-column', 'color-neutral-darker')
  }, /*#__PURE__*/React.createElement(Type, {
    color: matchScoreCTATextColor,
    onClick: handleMatchScoreCTAOnClick,
    size: 1
  }, matchScoreCTAText), /*#__PURE__*/React.createElement("div", {
    className: classes('display-inline-flex', 'margin-bottom-0')
  }, /*#__PURE__*/React.createElement(Type, {
    color: matchScoreCTATextColor,
    size: 1,
    className: classes('margin-right-1')
  }, "match score"), /*#__PURE__*/React.createElement(MatchScoreTooltip, {
    analytics: analytics,
    identity: identity,
    marketplaceEntity: marketplaceEntity,
    taxonomy: taxonomy
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes('display-inline-flex', 'align-items-center'),
    onClick: handleMatchScoreCTAOnClick,
    role: "presentation"
  }, isKetoCard ? [matchScoreIcon, /*#__PURE__*/React.createElement(Type, {
    className: classes('margin-left-2'),
    color: "blue",
    size: 3,
    key: "1"
  }, "".concat(matchScore, "%"))] : [/*#__PURE__*/React.createElement(Type, {
    className: classes('margin-right-2', 'margin-left-2'),
    color: matchScoreColor,
    key: "0"
  }, "".concat(matchScore, "%")), matchScoreIcon]));
};

MatchScoreCTA.propTypes = {
  analytics: MatchScoreTooltip.propTypes.analytics,
  identity: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  marketplaceEntity: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  taxonomy: PropTypes.objectOf(PropTypes.string),
  isKetoCard: PropTypes.bool
};
MatchScoreCTA.defaultProps = {
  taxonomy: {},
  isKetoCard: false
};
export default MatchScoreCTA;